import React, { useRef } from "react";

import { Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import useMount from "~/hooks/useMount";

import SideMenu from "./components/SideMenu";

export default function AdminPrivateLayout({
  sideMenuItems,
  routesPrefix,
  unauthorizedRoutePath,
  authentication,
  apiClient,
}) {
  const navigate = useNavigate();
  const logoutListener = useRef();

  const logout = () => {
    authentication.logout();
    navigate(`/${routesPrefix}/${unauthorizedRoutePath}`);
  };

  useMount(() => {
    logoutListener.current = apiClient.addAuthExpiredListener(() => {
      logout();
    });

    return () => {
      apiClient.removeAuthExpiredListener(logoutListener.current);
    };
  });

  return (
    <div className="flex">
      <SideMenu
        items={sideMenuItems}
        routesPrefix={routesPrefix}
        user={authentication.user}
        logout={logout}
      />
      <div className="bg-slate-900 bg-opacity-95 w-full h-screen text-white flex flex-col">
        <Outlet />
      </div>
    </div>
  );
}
